import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IIdentifierWrite, TIdentifierRecordType } from './types';

/**
 * Writes a record's identifiers. Atomic per record: every value in the payload is written
 * or none is, so a form that is refused leaves nothing half saved.
 *
 * A null value deletes that key for that instance.
 *
 * Core refuses an undeclared key, a value that does not match its declared type, and a
 * value another record already holds for a key declared unique. The message names the key,
 * so it is surfaced to the operator rather than replaced with something generic.
 */
export const updateRecordIdentifiers = async (
  recordType: TIdentifierRecordType,
  recordId: string,
  writes: IIdentifierWrite[],
): Promise<void> => {
  const url = `${API_URL}/extensions/records/${recordType}/${recordId}/identifiers`;
  const res = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(writes),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  if (!res.ok) {
    const body = await res.json().catch(() => undefined);
    throw new Error(body?.message || 'Could not save the integrations values');
  }
};
